// Frame around every stage: number, title, blurb, status pill, body slot,
// and the Back / Advance nav. Stages render only their own body inside.

export default function StageShell({
  stage,
  status,
  currentIdx,
  total,
  onBack,
  onAdvance,
  advanceLabel,
  advanceDisabled,
  children,
}) {
  const isLast = currentIdx === total - 1;
  const computedLabel =
    advanceLabel ??
    (isLast
      ? status === "done" ? "✓ Journey complete" : "Mark complete"
      : status === "done" ? "Next →" : "Mark done & continue →");

  return (
    <div className="s-stage-wrap">
      <div className="s-stage">
        <div className="s-stage-head">
          <span className="s-stage-num">Step {currentIdx + 1}</span>
          <span className={`s-stage-status ${status}`}>{status.replace("_", " ")}</span>
        </div>
        <h1 className="s-stage-title">{stage.title}</h1>
        <p className="s-stage-blurb">{stage.blurb}</p>

        <div className="s-stage-body">{children}</div>

        <div className="s-stage-actions">
          <button
            type="button"
            className="s-btn ghost"
            onClick={onBack}
            disabled={currentIdx === 0}
          >← Back</button>
          <button
            type="button"
            className="s-btn primary ml-auto"
            onClick={onAdvance}
            disabled={advanceDisabled || (isLast && status === "done")}
          >{computedLabel}</button>
        </div>
      </div>
    </div>
  );
}
